import { Container } from "react-bootstrap";
import './MyActivity.scss';
import StakingInProgressTable from "./StakingInProgressTable";
import TransactionHistoryTable from "./TransactionHistoryTable";

const MyActivity = () => {
    return (
        <section className="my_activity">
            <Container>
                <h2>My Activity</h2>
                <StakingInProgressTable />
                <TransactionHistoryTable />
            </Container>
        </section>
    )
}

export default MyActivity